export const WHITELABEL_TENANT_IDS = {
  MBN: 'VGVuYW50Tm9kZToxNQ==',
  JWA: 'VGVuYW50Tm9kZTozMzg=',
  DRESSLER: 'VGVuYW50Tm9kZTo5MDc=',
  SCHMEING: 'VGVuYW50Tm9kZToxOTcz',
  BREMER: 'VGVuYW50Tm9kZTozOTE3',
};
